function buildRoute(params, url) {
    const baseUrl = url.endsWith('/') ? url.substring(0, url.length - 1) : url;
    return [baseUrl, ...params.map((key) => '{' + key + '}')].join('/');
}
export function defineApiGetCall(api, routeName, definition, namespace, secure) {
    const route = definition.params ? buildRoute(definition.params, definition.route) : definition.route;
    const httpCall = (urlParams, options) => {
        const get = secure ? api.http.authenticatedGet : api.http.get;
        return get(route, urlParams, {
            headers: {
                ...definition.headers,
                ...options?.headers,
            },
            nativeProcessing: options?.nativeProcessing ?? definition.nativeProcessing,
            abortSignal: options?.abortSignal,
            method: options?.method ?? definition.method,
        }).then(async (result) => {
            if (!result) {
                return result;
            }
            if (!definition.process) {
                return result.payload;
            }
            return await definition.process(result.payload, result.response);
        });
    };
    const apiCall = Object.assign(httpCall, {
        abortable: (abortSignal) => (urlParams, options) => httpCall(urlParams, {
            abortSignal: abortSignal,
            ...options,
        }),
    });
    const dynamic = api;
    if (!dynamic[namespace]) {
        dynamic[namespace] = {};
    }
    dynamic[namespace][routeName] = apiCall;
    return api;
}
